import { ChangeDetectionStrategy, Component, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { merge, Subject, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoginValue } from './login-value';

@Component({
  selector: 'mstar-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent implements OnDestroy {

  // == CONSTANTS ========================================================

  @Input() 
  set processing(processing: boolean) {
    this._processing.next(processing);
  }
  @Output() loginFormSubmit = new EventEmitter<LoginValue>();

  // == STATE ============================================================

  form = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
    application: 'kiosk'
  });

  _processing = new BehaviorSubject<boolean>(false);
  processing$ = this._processing.asObservable();

  // == ACTIONS ==========================================================

  login = new Subject<void>();
  login$ = this.login.asObservable();

  // == SIDE EFFECTS =====================================================

  onLogin$ = this.login$.pipe(
    tap(_ => this.loginFormSubmit.emit(this.form.value))
  );

  // == SUBSCRIPTIONS ====================================================

  subscriptions = merge(
    this.onLogin$
  ).subscribe();

  // == LIFECYCLE ========================================================

  constructor(private formBuilder: FormBuilder) { }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
